import React from 'react';
import { Button, Container, CssBaseline, Menu, MenuItem } from '@mui/material';
import CustomInput from '../../../../../Components/CustomInput/CustomInput';
import Grid from '@mui/material/Grid';
import axios from 'axios';
import CustomSnackbar from '../../../../../Components/Snackbar/Snackbar';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { genURL, genURLTEST } from '../../../../../_getjson';
import PropTypes, { number } from "prop-types";
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';

import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import UseAutocomplete from '../../../../../Components/CustomInput/UseAutocompletes';
import Splittext from '../../../../../CustomFunction/Splittext/Splittext';
export default function Addcategory(props) {
    const { AddData } = props
    const [categoryName, setCategoryName] = React.useState("")
    const [categoryNameen, setCategoryNameen] = React.useState("")
    const [defaultcategoryNameen, setDefaultcategorynameen] = React.useState("")
    const [defaultcategoryName, setDefaultcategoryname] = React.useState("")
    //----------------------------alert ----------------------------
    const [color, setColor] = React.useState("")
    const [opensnackbar, setOpensnackbar] = React.useState(false)
    const [autoClose, setAutoClose] = React.useState(3600)
    const [messagealert, setMessagealert] = React.useState("")
    const [icon, setIcon] = React.useState("")

    const [lv, setLv] = React.useState('0');
    const [categoryrefID, setCategoryrefID] = React.useState("")

    const [categorymainrefID, setCategorymainrefID] = React.useState("")

    const [category, setCategory] = React.useState([])

    const [defaultvaluecate, seDefaultvaluecate] = React.useState("")

    React.useMemo(() => {
        setDefaultcategoryname(AddData)
        setDefaultcategorynameen(" ")
    }, [AddData])

    React.useEffect(() => {
        loadCate()
        setCategoryrefID("")
        setCategorymainrefID("")
    }, [lv])

    const loadCate = async () => {
        //in host
        let url = "/reportmanage/category?"
        //test
        // let url = `category?`
        let elementcategory = []
        // console.log("resdata getCategory", genpostURLTEST(url));
        await axios.get(genURL(url)).then(res => {
            // await axios.post(genpostURLTEST(url), parameter).then(res => {
            console.log("resdata", res.data);
            if (res.data.length > 0) {
                for (let index = 0; index < res.data.length; index++) {
                    if (res.data[index].catelevel === Number(lv) - 1) {
                        elementcategory.push({ CODE: res.data[index].id, MYNAMETH: res.data[index].mainref + ":" + res.data[index].nameTH })
                    }
                }
            }
        }).catch(error => {
            console.log("resdata", error);
            // this.setState({ opensnackbar: true })
            // this.setState({ color: "warning" })
            // this.setState({ icon: ErrorIcon })
            // this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
            // this.setState({ openBackdrop: false })
        });
        await setCategory(elementcategory)
    }
    const saveCategory = async () => {
        const paramData = new URLSearchParams();
        paramData.append("nameTH", categoryName !== "" ? categoryName.trim() : defaultcategoryName.trim());
        paramData.append("nameEn", categoryNameen.trim());
        paramData.append("catelevel", lv);
        paramData.append("categoryrefID", categoryrefID);
        paramData.append("categorymainrefID", categorymainrefID);
        for (var pair of paramData.entries()) {
            if (typeof pair[1] === "undefined") {
                pair[1] = "";
            }
            if (pair[0] === "nameTH" && pair[1] === "") {
                setMessagealert("กรุณากรอกชื่อหมวดหมู่(TH)")
                setColor("warning")
                setOpensnackbar(true)
                setIcon(< ReportProblemRoundedIcon />)
                return;
            }
            if (pair[0] === "nameEn" && pair[1] === "") {
                setMessagealert("กรุณากรอกชื่อหมวดหมู่(EN)")
                setColor("warning")
                setOpensnackbar(true)
                setIcon(< ReportProblemRoundedIcon />)
                return;
            }
        }
        let url = 'reportmanage/category?'
        //let url = 'category?'
        let res = await axios.post(genURL(url), paramData)
        console.log("saveCategory", res)
        if (res.data.status === "success") {

            await setCategoryName("-")
            await setCategoryNameen("-")
            await setDefaultcategoryname("-")
            await setDefaultcategorynameen("-")

            await setCategoryName("")
            await setCategoryNameen("")
            await setDefaultcategoryname("")
            await setDefaultcategorynameen("")

            await setMessagealert("บันทึกสำเร็จ")
            await setColor("success")
            await setOpensnackbar(true)

            await setIcon(< CheckCircleOutlineRoundedIcon />)

        }
        //  await setDefaultcategoryname(null)
    }
    const handleChange = (e) => {
        setLv(e.target.value);
    }
    const setvalue = async (e, type) => {
        console.log("e setvalue" + e[0].CODE);
        if (type == "category") {
            setCategoryrefID(e[0].CODE)
            let MG = Splittext(e[0].MYNAMETH, ":")
            setCategorymainrefID(MG[0] === "0" ? e[0].CODE : MG[0])
        }
    }
    return (<React.Fragment>
        <br />
        <CssBaseline />
        <Container>
            <CustomInput label='ชื่อหวดหมู่(TH)' resData={e => { setCategoryName(e) }} inputType={"text"} defaultValue={defaultcategoryName} id={"categoryName"} />
            <CustomInput label='ชื่อหวดหมู่(EN)' resData={e => { setCategoryNameen(e) }} inputType={"text"} defaultValue={defaultcategoryNameen} id={"categoryNameen"} />

            <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={lv}
                    label="lv"
                    onChange={handleChange}
                    sx={{
                        fontFamily: "Customfont",
                        "& label.Mui-focused": {
                            display: "none",
                        },
                        "& legend": {
                            display: "none",
                        },
                    }}
                >
                    <MenuItem value={"0"} sx={{ fontFamily: "Customfont" }}>ระดับ 0</MenuItem>
                    <MenuItem value={"1"} sx={{ fontFamily: "Customfont" }}>ระดับ 1</MenuItem>
                    <MenuItem value={"2"} sx={{ fontFamily: "Customfont" }}>ระดับ 2</MenuItem>
                    <MenuItem value={"3"} sx={{ fontFamily: "Customfont" }}>ระดับ 3</MenuItem>
                    <MenuItem value={"4"} sx={{ fontFamily: "Customfont" }}>ระดับ 4</MenuItem>
                    <MenuItem value={"5"} sx={{ fontFamily: "Customfont" }}>ระดับ 5</MenuItem>
                    <MenuItem value={"6"} sx={{ fontFamily: "Customfont" }}>ระดับ 6</MenuItem>
                    <MenuItem value={"7"} sx={{ fontFamily: "Customfont" }}>ระดับ 7</MenuItem>
                    <MenuItem value={"8"} sx={{ fontFamily: "Customfont" }}>ระดับ 8</MenuItem>
                    <MenuItem value={"9"} sx={{ fontFamily: "Customfont" }}>ระดับ 9</MenuItem>
                </Select>
            </FormControl>
            {lv > 0 ? <Grid container spacing={2} sx={{ marginTop: 0 }}>
                <Grid item xs={12}>
                    <UseAutocomplete title="หมวดหมู่" id="categoryaddcate"
                        datalist={category}
                        valueReturn={e => setvalue(e, "category")}
                        placeholder={""}
                        defaultvalue={defaultvaluecate}
                        adddataenable={false}
                        activate={e => console.log(" category activate")}
                    />
                </Grid>
            </Grid> :
                <></>}
            <Grid container spacing={2}>
                <Grid item xs={8}>
                </Grid>
                <Grid item xs={4} sx={{ textAlign: 'end' }} >
                    <Button variant="outlined" size="small" sx={{
                        marginLeft: 1, marginLeft: 1,
                        fontFamily: "Customfont !important"
                    }} onClick={_ => saveCategory()}>บันทึก</Button>
                    <Button variant="outlined" size="small" sx={{
                        marginLeft: 1, marginLeft: 1
                        , fontFamily: "Customfont!important"
                    }} onClick={_ => props.CloseDialog(false)}>ปิด</Button>
                </Grid>
            </Grid>
            <CustomSnackbar place="bl"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setOpensnackbar(false) }}
                close />
        </Container>
    </React.Fragment>
    )
}
Addcategory.propTypes = {
    AddData: PropTypes.string
}